import { Ti18nKeys } from "../../../../constants/i18n";
import { VERIFIED_STATUS_VALUE } from "./user-field-groups/field-definitions";

export const getActivationLabelKey = (
  verificationStatus: string
): Ti18nKeys => {
  return verificationStatus === VERIFIED_STATUS_VALUE
    ? "ACTIVATED"
    : "NOT_ACTIVATED";
};
